module.exports = __webpack_public_path__ + "static/media/company_history_shoplive.7ccfae1d.mp4";